module.exports = __webpack_public_path__ + "img/photo3.ead034fc.png";